import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  PersianDataPicker,
  RadioButton,
  TextArea,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  toDatePicker,
  dateTimeToserver,
} from "lib/helpers";
import Modal from "components/Modal";

// components

export default function ManageComment(props) {
  const { show, item } = props;
  const [replyBody, setReplyBody] = useState("");

  useEffect(() => {
    if (show) {
      setReplyBody("");
    }
  }, [show, item && item.id]);

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <div className="mt-3 text-center sm:mt-0 sm:mr-4 sm:text-right">
          <div className="mt-2">
            <p className="text-sm text-gray-900">
              کاربر:
              <br />
              {props.item && props.item.creator && props.item.creator.full_name}
              <br />
              {props.item && props.item.creator && props.item.creator.user_name}
            </p>
          </div>
          <div className="mt-2">
            <p className="text-sm text-gray-900">
              نظر:
              <br />
              {props.item && props.item.body}
            </p>
          </div>

          <div className="mt-2">
            <p className="text-sm text-gray-900">
              برای محصول:
              <br />
              {props.item.commentable && props.item.commentable.detail.title}
            </p>
          </div>

          <div className="mt-2">
            <p className="text-sm text-gray-900">پاسخ:</p>
            <textarea
              value={replyBody}
              onChange={(e) => setReplyBody(e.target.value)}
              className="form-control"
              rows={4}
              placeholder="پاسخ خود را بنویسید"
            />
          </div>

          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              disabled={props.load || !replyBody.trim()}
              onClick={() => props.reply(replyBody.trim())}
              className="btn btn-primary w-20 mr-1"
            >
              پاسخ
            </button>
            <button
              type="button"
              disabled={props.load}
              onClick={props.accept}
              className="btn btn-primary w-20 mr-1"
            >
              تایید
            </button>
            <button
              type="button"
              disabled={props.load}
              onClick={props.delete}
              className="btn btn-outline-secondary w-20 mr-1"
            >
              حذف
            </button>
            <button
              type="button"
              disabled={props.load}
              onClick={props.close}
              className="btn btn-outline-secondary w-20 mr-1"
            >
              بستن
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
